import { Box, Stack } from '@mui/material';
import React from 'react';

import StatusLight, { type StatusLightType } from '../StatusLight';
import { MobileCaption, MobileSubtitle } from '../Typography';

export interface DocumentItemStatusLight {
  type: StatusLightType;
  label?: string;
}

export interface DocumentItemProps {
  primaryText: string;
  amount: string | number;
  secondaryText?: string;
  statusLights?: DocumentItemStatusLight[];
  onClick?: () => void;
}

const DocumentItem: React.FC<DocumentItemProps> = ({
  primaryText,
  amount,
  secondaryText,
  statusLights = [],
  onClick,
}) => {
  const hasSecondaryText = secondaryText != null && secondaryText !== '';
  const hasStatusLights = statusLights.length > 0;
  const handleClick = onClick ?? (() => {});

  return (
    <Box
      component="button"
      type="button"
      onClick={handleClick}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        border: 'none',
        borderRadius: 0,
        p: 0,
        py: 1.5,
        backgroundColor: 'transparent',
        cursor: 'pointer',
        textAlign: 'left',
        '&:not(:first-of-type)': {
          borderTop: 1,
          borderColor: 'divider',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Stack spacing={0.25}>
            <MobileSubtitle
              component="span"
              sx={{ fontSize: '1rem', fontWeight: 600, color: 'text.primary' }}
            >
              {primaryText}
            </MobileSubtitle>
            {hasSecondaryText && (
              <MobileCaption
                component="span"
                sx={{ color: 'text.secondary', fontWeight: 400 }}
              >
                {secondaryText}
              </MobileCaption>
            )}
          </Stack>
        </Box>
        <MobileSubtitle
          component="span"
          sx={{
            flexShrink: 0,
            ml: 2,
            color: 'text.primary',
            fontSize: '1rem',
          }}
        >
          {amount}
        </MobileSubtitle>
      </Box>
      {hasStatusLights && (
        <Box sx={{ mt: 1, pt: 1 }}>
          <Stack spacing={1} direction="column">
            {statusLights.map((light, index) => (
              <StatusLight
                key={`status-light-${index}`}
                type={light.type}
                label={light.label}
              />
            ))}
          </Stack>
        </Box>
      )}
    </Box>
  );
};

export default DocumentItem;
